var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionPatternRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    height: 731,
    viewBox: "0 0 636 731",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 636,
    height: 731
  }, /*#__PURE__*/React.createElement("rect", {
    width: 636,
    height: 731,
    fill: "#43BFF3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M801.868 -44.3774L649.339 524.868L80.094 372.339L232.623 -196.906L801.868 -44.3774ZM659.078 38.0624L315.063 -54.1163L222.884 289.899L566.899 382.078L659.078 38.0624Z",
    fill: "#43BFF3",
    stroke: "#43BFF3",
    strokeWidth: 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionPatternRightBlue);
export default __webpack_public_path__ + "static/media/SectionPatternRightBlue.8566602c7de86f4a103f66140a6d836c.svg";
export { ForwardRef as ReactComponent };